<div class="login-wrapper"></div>
<app-common-modal
  modalId="no-certs-modal"
  [title]="'LOGIN_PAGE.NO_CERTS_MODAL.TITLE' | translate"
  [(visible)]="noCertsModalVisible"
  [config]="{ size: 'md', persistent: true, hideButtons: true }"
  (onClose)="onToggleNoCertsModal(false)">
  <!-- START CONTENT -->
  <div class="modal-content-oauth2">
    <img
      src="assets/images/cert-suspended.svg "
      width="80 !important"
      height="80 !important" />
    <div class="title" translate>LOGIN_PAGE.NO_CERTS_MODAL.TITLE</div>
    <div class="text" translate>LOGIN_PAGE.NO_CERTS_MODAL.DESC</div>
    <div class="text" translate>LOGIN_PAGE.NO_CERTS_MODAL.CONTACT</div>
    <ng-ui-kit-button
      (onClick)="openSupport()"
      color="primary"
      [label]="'LOGIN_PAGE.NO_CERTS_MODAL.BUTTON' | translate"
      type="button"
      size="sm">
    </ng-ui-kit-button>
  </div>
  <!-- END CONTENT -->
</app-common-modal>
